import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { defaultHeaders } from '@redux/api/Config';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import config from '@app/config';
import { ModalProductType, ProductType } from '@entities/Catalog';
import { PaginationType } from '@entities/Catalog/module/types/catalogSchema';
import { dataModels } from '@entities/Catalog/module/services/mockdata';
import { Part, PartProduct } from '@entities/Product';

function isHydrateAction(action: Action): action is PayloadAction<any> {
  return action.type === HYDRATE;
}

export function getParametersProcessing(value: string, regionId: number, sparky?: number[]): string {
  if (sparky && sparky.length > 0) {
    return (
      value?.replaceAll(sparky.map(x => `slaveId[]=${x}`).join('&'), '') +
      '&' +
      sparky.map(x => `slaveId[]=${x}`).join('&') +
      `&regionId=${regionId}`
    ).replaceAll('&&', '&');
  }

  return (value + `&regionId=${regionId}`)?.replaceAll('tyres_profile=0', '')?.replaceAll('&&', '&');
}

export const catalogApi = createApi({
  reducerPath: 'catalogApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.baseApiUrl,
    prepareHeaders: defaultHeaders,
  }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (isHydrateAction(action)) {
      return action.payload[reducerPath];
    }
  },
  endpoints: builder => ({
    getListProducts: builder.query<{ data: ProductType[]; pagination: PaginationType }, { params: string; regionId: number }>({
      query: ({ params, regionId }) => '/api/catalog/filter' + getParametersProcessing(params, regionId),
      transformResponse: (response: { data; pagination }): { data: ProductType[]; pagination: PaginationType } => response,
    }),
    getListModels: builder.query<{ data: ModalProductType[]; pagination: PaginationType }, { params: string; regionId: number }>({
      query: ({ params, regionId }) => '/api/catalog/models/filter' + getParametersProcessing(params, regionId),
      transformResponse: (response: { data; pagination }): { data: ModalProductType[]; pagination: PaginationType } => response,
    }),
    getListSparky: builder.query<
      { data: ModalProductType[]; pagination: PaginationType },
      { fetchParams: string; sparky: number[]; regionId: number }
    >({
      query: ({ fetchParams, sparky, regionId }) => '/api/catalog/sparky/filter' + getParametersProcessing(fetchParams, regionId, sparky),
      transformResponse: (response: { data; pagination }): { data: ModalProductType[]; pagination: PaginationType } => response,
    }),
  }),
});

export const { useGetListProductsQuery, useGetListModelsQuery, useGetListSparkyQuery, endpoints: catalogEndpoints } = catalogApi;
